export default __webpack_public_path__ + "static/media/09-large.0a5b4774.jpg";